import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';
import { TUpdateWorkspaceBillingInfo } from '../types/workspace-billing-info';

export const getWorkspaceBillingInfo = (workspaceID: string) => {
    const query = {
        workspaceID,
    };
    const url = `${OCTOPUS_BASE_URL}/workspace-billing-info/`;
    const response = axios.get(url, { params: query });
    return response;
};

export const updateWorkspaceBillingInfo = (payload: TUpdateWorkspaceBillingInfo) => {
    const url = `${OCTOPUS_BASE_URL}/workspace-billing-info/`;
    const response = axios.put(url, payload);
    return response;
};
